/** "19:30" — an instant on the viewer's own clock, such as when a venue reopens or an order is ready. */
export const formatClockTime = (instant: string): string =>
  new Date(instant).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
